// Paket Sipariş Yönetim Sistemi sayfası kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'sales.orderManagementPage';

export const orderManagementPageGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'Paket Sipariş Yönetim Sistemi nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Bu sayfada paket ekranlarınızı oluşturur, ayarlarını yapar ve kasiyerin sipariş aldığı ekranı açarsınız. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık'),
    filters: t(`${G}.regions.filters`, 'Şube ve ekran arama'),
    toolbar: t(`${G}.regions.toolbar`, 'Ekle ve ⋮ menüsü'),
    table: t(`${G}.regions.table`, 'Paket ekranları'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Paket ekranı nedir?'),
      text: t(`${G}.s1.text`, 'Paket ekranı, bir şubenin telefon siparişlerini ve yemek platformu (Yemeksepeti, Uber Eats, Migros vb.) siparişlerini tek yerden karşıladığı sipariş ekranıdır. Kasiyer siparişi orada alır, mutfağa yollar, kuryeye verir ve ödemeyi kapatır.'),
      tips: [
        t(`${G}.s1.tip1`, '"Tüm Siparişler" düğmesi bütün kanallardaki siparişleri tek listede gösterir.'),
      ],
    },
    {
      region: 'toolbar',
      title: t(`${G}.s2.title`, '2. Yeni paket ekranı ekleyin'),
      text: t(`${G}.s2.text`, '"Paket Ekranı Ekle" düğmesine basın, ekran adını yazın ve ekranın çalışacağı şubeyi seçin. Henüz ekran yoksa ortadaki "İlk Paket Ekranını Oluştur" düğmesi de aynı pencereyi açar.'),
      tips: [
        t(`${G}.s2.tip1`, 'Her şubeye yalnızca bir paket ekranı tanımlanabilir.'),
        t(`${G}.s2.tip2`, 'Şirketinizde şubeye bağlı paket ekranı varsa yeni ekranda şube seçimi zorunludur.'),
      ],
    },
    {
      region: 'filters',
      title: t(`${G}.s3.title`, '3. Ekranı bulun'),
      text: t(`${G}.s3.text`, 'Şube filtresiyle listeyi daraltın ya da arama kutusuna ekran adını yazın. Şubesi olmayan ekranlar "Şube Atanmamış" olarak görünür.'),
    },
    {
      region: 'table',
      title: t(`${G}.s4.title`, '4. Ekranı açın, düzenleyin, ayarlayın'),
      text: t(`${G}.s4.text`, '"Ekrana Git" paket sipariş ekranını açar; kasiyer siparişleri burada alır. Satırdaki ⋮ düğmesi ekranın işlemlerini açar.'),
      tips: [
        t(`${G}.s4.tip1`, 'Düzenle: ekranın adını ve şubesini değiştirir.'),
        t(`${G}.s4.tip2`, 'Ayarlar: ekranın Ödeme Yöntemleri, Kasiyer Atama, Depo/Stok, Yazdırma ve Entegrasyonlar gibi ayarlarını açar.'),
      ],
    },
    {
      region: 'toolbar',
      title: t(`${G}.s5.title`, '5. ⋮ menüsü: gün sonu ve müşteri aktarımı'),
      text: t(`${G}.s5.text`, '"Paket Ekranı Ekle" yanındaki ⋮ düğmesi ek işlemleri açar.'),
      tips: [
        t(`${G}.s5.tip1`, 'Gün Sonu Raporu: seçtiğiniz zaman aralığındaki satışları toplar ve gün sonunu kaydeder.'),
        t(`${G}.s5.tip2`, 'Gün Sonları Listesi: daha önce kaydedilmiş gün sonlarını gösterir.'),
        t(`${G}.s5.tip3`, 'Müşteri Aktar: müşteri listenizi Excel dosyasından toplu olarak yükler.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s6.title`, '6. Ekranı silin'),
      text: t(`${G}.s6.text`, 'Satırdaki ⋮ menüsünden "Sil" seçin ve onay penceresinde yeniden "Sil"e basın. Ekran listeden kaldırılır; bu işlem geri alınamaz. Başlıktaki (i) düğmesi bu rehberi her zaman yeniden açar.'),
    },
  ],
});
